import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useDebug } from '@/hooks/useDebug';

export function ConsoleViewer() {
  const { logs } = useDebug();

  return (
    <div className="space-y-2 text-xs">
      {logs.slice(0, 300).map((l) => (
        <Card key={l.id}>
          <CardContent className="pt-3">
            <div className="flex items-center justify-between">
              <div className="font-medium">{l.level.toUpperCase()}</div>
              <div className="opacity-70">{new Date(l.timestamp).toLocaleTimeString()}</div>
            </div>
            <pre className="mt-2 whitespace-pre-wrap break-words">{l.message}
{l.args ? JSON.stringify(l.args, null, 2) : ''}</pre>
          </CardContent>
        </Card>
      ))}
      {logs.length === 0 && <div className="opacity-70">No logs captured yet.</div>}
    </div>
  );
}
